/**
 * i18n bootstrap. Default locale is `es-MX`; `en-US` is loaded as a fallback
 * for development testing and never as the user-facing default.
 */

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enUS from "@/i18n/locales/en-US.json";
import esMX from "@/i18n/locales/es-MX.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "es-MX": { translation: esMX },
      "en-US": { translation: enUS },
    },
    fallbackLng: "es-MX",
    supportedLngs: ["es-MX", "en-US"],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      // Prefer the browser language but fall back to es-MX if it's unsupported.
      order: ["querystring", "navigator", "htmlTag"],
      caches: [],
    },
  });

export default i18n;
